import { AutocompleteGetTagProps, Chip, useTheme } from "@mui/material";

type MuiSelectChipNewProps = {
  getTagProps: AutocompleteGetTagProps;
  labels: { [p: string]: string };
  index: number;
  valueId: string | number;
};

export const MuiSelectChip = ({ getTagProps, labels, index, valueId }: MuiSelectChipNewProps) => {
  const theme = useTheme();

  return (
    <Chip
      {...getTagProps({ index })}
      label={labels[valueId] ?? "NOT FOUND"}
      size="small"
      sx={{
        background: theme.palette.primary.main,
        color: theme.palette.text.primary,
        "& .MuiChip-deleteIcon": {
          color: theme.palette.text.secondary,
        },
      }}
    />
  );
};
